import styled from "styled-components";

export const CreateTaskButton = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom : 20px;
    align-items: center;
`
export const TaskListContainer = styled.div`
    display : flex;
    flex-direction : row;
    justify-content: space-between;
`

export const PreLiveClass = styled.div`

`

export const LiveClassTitle = styled.div`
    font-family: Rubik;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
    margin-bottom : 20px;
    width : 400px;
`